<mat-drawer-container [@.disabled]="true" hasBackdrop="true" (backdropClick)="clearSelected(); drawer.close()" autosize>
  <div class="fxLayout">
    <section id="calendar" fxFlex>
      <div class="calendar-header" *ngIf="mode$ | async as mode" fxLayout fxLayout.lt-md="column" fxLayoutGap="12px">
        <ng-container *ngIf="calendarPermissions$ | async as calendarPermissions">
          <div fxLayout fxLayoutAlign="space-between">
            <h4 #dateMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="dateMenu">
              {{
                dates.length
                  ? (dates[0] | date: 'mediumDate') + ' - ' + (dates[dates.length - 1] | date: 'mediumDate')
                  : 'Calendar'
              }}
            </h4>

            <div fxHide fxShow.lt-md>
              <ng-container
                *ngTemplateOutlet="
                  calendarModeSwitcher;
                  context: { calendarPermissions: calendarPermissions, mode: mode, setMode: setMode }
                "></ng-container>
            </div>
          </div>

          <div fxFlex>
            <sbnb-filter
              #filterComponent
              componentName="properties"
              [customEndpoint]="filterUrl"
              buttonLabel="+ Filter properties"
              [hideSaveSegment]="true"
              (filterChanged)="handleFilterChanged($event)"
              (reset)="filterReset()"></sbnb-filter>

            <mat-menu #dateMenu="matMenu" class="filters__cdk-menu">
              <sbnb-date-picker
                [numMonths]="1"
                [rangeSelect]="false"
                [checkInOutStyling]="false"
                [showDurationLabels]="false"
                (click)="$event.stopPropagation()"
                (datesSelected)="miniCalDatesChanged($event)"></sbnb-date-picker>
            </mat-menu>
          </div>

          <div fxHide.lt-md>
            <ng-container
              *ngTemplateOutlet="
                calendarModeSwitcher;
                context: { calendarPermissions: calendarPermissions, mode: mode, setMode: setMode }
              "></ng-container>
          </div>

          <div fxHide.lt-md fxLayout fxLayoutGap="12px">
            <sbnb-add-manual-booking-button
              *ngIf="calendarPermissions.hasReservationsManagementAccess"
              (bookingChanged)="fetchUpdatedReservationDetails()"
              (customQuoteCreated)="onCustomQuoteCreated($event)"></sbnb-add-manual-booking-button>
          </div>
        </ng-container>
      </div>

      <div *ngIf="loading" fxLayout fxLayoutAlign="center center">
        <mat-spinner [diameter]="32"></mat-spinner>
      </div>

      <div #scroller class="calendar-scroller">
        <div *ngIf="!loading && (!properties || properties.length === 0)" class="no-properties">
          <span *ngIf="activeFilters?.length === 0">No properties found.</span>
          <span *ngIf="activeFilters?.length > 0">
            No properties found matching these filters. Try
            <span class="raspberry-darker strong clickable" (click)="filterReset()">removing your filters</span>
          </span>
        </div>
        <ng-container *ngIf="calendarPermissions$ | async as calendarPermissions">
          <div
            *ngIf="dates && properties && properties.length > 0"
            class="calendar"
            [style.height.px]="calendarHeight$ | async">
            <div class="calendar-left" [class.left-minimised]="minimisedLeft">
              <div class="hider"></div>
              <div class="property-search">
                <svg
                  *ngIf="!minimisedLeft && !hasMoreProperties"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.80667 9.33333H10.3333L13.66 12.6667L12.6667 13.66L9.33333 10.3333V9.80667L9.15333 9.62C8.39333 10.2733 7.40667 10.6667 6.33333 10.6667C3.94 10.6667 2 8.72667 2 6.33333C2 3.94 3.94 2 6.33333 2C8.72667 2 10.6667 3.94 10.6667 6.33333C10.6667 7.40667 10.2733 8.39333 9.62 9.15333L9.80667 9.33333ZM3.33333 6.33333C3.33333 7.99333 4.67333 9.33333 6.33333 9.33333C7.99333 9.33333 9.33333 7.99333 9.33333 6.33333C9.33333 4.67333 7.99333 3.33333 6.33333 3.33333C4.67333 3.33333 3.33333 4.67333 3.33333 6.33333Z"
                    fill="#D0CDD4" />
                </svg>

                <input
                  *ngIf="!minimisedLeft && !hasMoreProperties"
                  class="search-input"
                  type="search"
                  (input)="searchCriteria$.next($any($event?.target)?.value ?? '')"
                  placeholder="Property name" />

                <!-- spacer -->
                <div *ngIf="hasMoreProperties" fxFlex></div>

                <img
                  class="clickable"
                  [class.rotate-arrow]="minimisedLeft"
                  style="padding: 12px"
                  src="/assets/iconography/small-arrow-left.svg"
                  (click)="minimisedLeft = !minimisedLeft" />
              </div>

              <ng-container
                *ngFor="let property of properties; trackBy: trackById"
                [ngTemplateOutlet]="propertyLeftTemplate"
                [ngTemplateOutletContext]="{
                  property: property,
                  searchCriteria: searchCriteria$ | async
                }"></ng-container>

              <ng-template #propertyLeftTemplate let-property="property" let-searchCriteria="searchCriteria">
                <div
                  *ngIf="
                    searchCriteria.length === 0 ||
                    property.name.toLowerCase().indexOf(searchCriteria.toLowerCase()) > -1
                  "
                  class="property"
                  [class.is-last-child]="property.lastChild"
                  [class.limited]="property.calendar_restricted"
                  [matTooltip]="property.calendar_restricted ? 'This calendar is limited' : null">
                  <sbnb-icon
                    [size]="12"
                    icon="alert-circle"
                    class="absolute z-10 left-9 bottom-[6px] text-night"
                    *ngIf="property.calendar_restricted"></sbnb-icon>
                  <img
                    *ngIf="!property.isChild || minimisedLeft"
                    class="property-image"
                    [class.minimised-left-parent-child-property-img]="minimisedLeft && property.isChild"
                    [src]="property.thumbnail" />

                  <div *ngIf="property.isChild && !minimisedLeft" class="child-arrow">
                    <div class="child-arrow-vertical"></div>
                    <div class="child-arrow-horizontal"></div>
                    <div class="child-arrow-head"></div>
                  </div>

                  <a
                    (click)="openPropertyCalendar(property.id)"
                    *ngIf="!minimisedLeft"
                    class="property-name ellipsis"
                    style="width: 80px"
                    title="{{ property.name }}">
                    {{ property.name }}
                  </a>
                  <mat-spinner
                    *ngIf="property.pricingAndAvailabilityLoading"
                    class="property-spinner"
                    [diameter]="12"></mat-spinner>
                </div>
              </ng-template>
            </div>
            <div class="calendar-right" style="display: flex; flex-direction: column">
              <div class="right-headers" #rightHeaders>
                <div class="month-labels" [style.width.px]="rowWidth * dates.length">
                  <div class="month-label" *ngFor="let date of dates; index as i">
                    <div *ngIf="(date | date: 'd') === '1' || i === 0">
                      {{ date | date: 'MMM' }}
                    </div>
                  </div>
                </div>

                <div class="dates" [style.width.px]="rowWidth * dates.length">
                  <ng-container *ngFor="let date of dates">
                    <sbnb-calendar-header-date [date]="date"></sbnb-calendar-header-date>
                  </ng-container>
                </div>
              </div>

              <cdk-virtual-scroll-viewport
                appendOnly
                [itemSize]="50"
                orientation="horizontal"
                class="calendar-right"
                [minBufferPx]="1000"
                [maxBufferPx]="3000"
                (scroll)="syncScroll($event)"
                style="overflow-y: hidden">
                <!-- vertical date column -->
                <div class="vertical-dates">
                  <div class="date-column" *cdkVirtualFor="let date of dates">
                    <ng-container *ngIf="date | date: 'yyyy-MM-dd' as dateString">
                      <ng-container *ngIf="mode$ | async as mode">
                        <ng-container
                          *ngFor="let property of properties; trackBy: trackById"
                          [ngTemplateOutlet]="propertyRightTemplate"
                          [ngTemplateOutletContext]="{
                            property: property,
                            searchCriteria: searchCriteria$ | async
                          }"></ng-container>

                        <ng-template #propertyRightTemplate let-property="property" let-searchCriteria="searchCriteria">
                          <sbnb-calendar-cell
                            *ngIf="
                              searchCriteria.length === 0 ||
                              property.name.toLowerCase().indexOf(searchCriteria.toLowerCase()) > -1
                            "
                            [calendarStartDate]="dates[0]"
                            [date]="date"
                            [propertyId]="property.id"
                            [optimisticUpdate]="optimisticUpdates[property.id + '-' + dateString]"
                            [isClicked]="date === clickedDate && property.id === clickedProperty?.id"
                            [isRangeSelected]="selectedPropertyIds[property.id] && selectedDates[dateString]"
                            (reservationSelected)="reservationSelected($event)"
                            (dateClicked)="dateClicked($event)"
                            (dateHovered)="dateHovered($event)"></sbnb-calendar-cell>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
        </ng-container>
      </div>

      <div *ngIf="loadingMoreItems" class="property-loader" fxLayout fxLayoutAlign="center center">
        <mat-spinner diameter="30"></mat-spinner>
      </div>
    </section>
  </div>

  <mat-drawer #drawer [@.disabled]="true" mode="over" position="end" class="calendar__sidebar" fxLayout="column">
    <!-- pricing for multiple properties -->
    <!-- pricing -->
    <ng-container *ngIf="drawer.opened">
      <sbnb-sidebar-pricing
        *ngIf="!selectedReservation && clickedProperty && hoveredDates && (mode$ | async) !== 'tasks'"
        [property]="clickedProperty"
        [multipleProperties]="affectedProperties"
        [dates]="hoveredDates"
        [loading]="saving"
        [readonly]="clickedProperty.calendar_restricted && !affectedProperties?.length"
        readonlyTooltip="This calendar is limited"
        (close)="clearSelected(); drawer.close()"
        (manualBookingSaved)="fetchUpdatedReservationDetails()"
        (save)="setPriceAndAvailabilityValues($event)"
        (customQuoteCreated)="onCustomQuoteCreated($event)"></sbnb-sidebar-pricing>

      <!-- reservation -->
      <sbnb-sidebar-reservation
        *ngIf="selectedReservation"
        [selectedReservation]="selectedReservation"
        [clickedProperty]="clickedProperty"
        (close)="clearSelected(); drawer.close()"
        (reservationNeedsUpdating)="fetchUpdatedReservationDetails()"
        (openParentChildReservation)="openTrueParentChildReservation($event)"></sbnb-sidebar-reservation>

      <!-- tasks -->
      <sbnb-sidebar-tasks
        #sidebarTasks
        *ngIf="(mode$ | async) === 'tasks' && !selectedReservation"
        [tasks]="daysTasks"
        [selected]="selectedTask"
        [date]="{ date: clickedDate, hour: '10' }"
        [property]="clickedProperty"
        (taskCreated)="taskAdded($event)"
        (taskUpdated)="taskUpdated($event)"
        (taskDeleted)="taskDeleted($event)"
        (close)="clearSelected(); drawer.close()"></sbnb-sidebar-tasks>
    </ng-container>
  </mat-drawer>
</mat-drawer-container>

<ng-template #calendarModeSwitcher let-calendarPermissions="calendarPermissions" let-mode="mode" let-setMode="setMode">
  <mat-button-toggle-group
    *ngIf="calendarPermissions.hasCalendarAccess && calendarPermissions.hasTasksAccess"
    class="toggle-button"
    [value]="mode"
    (change)="setMode($event)">
    <mat-button-toggle value="occupancy" data-intercom-target="switcher-occupancy">Occupancy</mat-button-toggle>
    <mat-button-toggle value="tasks" data-intercom-target="switcher-tasks">Tasks</mat-button-toggle>
  </mat-button-toggle-group>
</ng-template>
